<template>
<div class="flow_dashboard_wrap mb-2">

<p class="text-primary ml-2 text-lg mb-0 cut-text " @click="show"><span class="font-semibold">{{getTheTranslation(flowsupplier.flow,"translation")}} </span></p>


<div class="grid mt-0">
<div class="col-6 ">




<Tag 
class="ml-2  mb-2 custom-chip" 
:value="flowtype" 
:style="'background-color:'+flowtypecolor"
/>

<Tag 
class="ml-2  mb-2 custom-chip" 
:value="flowstatus" 
:style="'background-color:'+flowstatuscolor"
/>
</div>





<div class="col-6">
<div class="flex justify-content-end flex-wrap">
<!--self_evaluation-->
<div v-if="flowsupplier.flow.type=='self_evaluation'">

</div>
<!--self_evaluation-->

<!--verification-->
<div v-if="flowsupplier.flow.type=='verification'">

	<template v-if="flowsupplier.status=='finished'">
		<p class="text-green-500  ml-2 font-semibold m-0 pr-4"> göster bitti</p>
	</template>
	<template v-if="flowsupplier.status=='started'">
		<p class="text-green-500  ml-2 font-semibold m-0 pr-4"> göster başladı</p>
	</template>
	<template v-if="flowsupplier.status=='created'">
		
		<template v-if="flowsupplier.verification.status=='scheduled' || flowsupplier.verification.status =='rescheduled'">
			<template v-if="isToday(flowsupplier.verification.schedule_date)=='today'">
				<p class="text-primary  ml-2 font-semibold m-0 pr-4"> bugün</p>
			</template>
			<template v-else-if="isToday(flowsupplier.verification.schedule_date)=='later'">
				
			</template>
			<template v-else>
				görüntüle
			</template>
		</template>
		<template v-if="flowsupplier.verification.status=='finished'">
			<p class="text-green-500  ml-2 font-semibold m-0 pr-4"> göster bitti</p>
		</template>
	</template>

</div>
<!--verification-->

<!--education-->
<div v-if="flowsupplier.flow.type=='education'">

</div>
<!--education-->

<!--audit-->
<div v-if="flowsupplier.flow.type=='audit'">

</div>
<!--audit-->


</div></div>




</div>




<template v-if="this.flowsupplier.flow.type=='self_evaluation' || this.flowsupplier.flow.type=='education'">
<template v-if="daydifference">
  <DateRangedisplay :daydifferencedata="daydifference" v-if="daydifference"></DateRangedisplay>
</template>
</template>



<template v-if="this.flowsupplier.flow.type=='verification'">
  <div class="grid">
    <div class="col">
      <div class="rage_wrap_outer ml-2 mb-1">
      <div class="rage_wrap_inner">
        <template v-if="verificationPlanning=='later'">
          <p class="text-primary font-semibold m-0 pr-4">
          <b>{{$store.state.languages.lang_phrases.planlama_tarihi}}:</b> 
          {{flowsupplier.verification.schedule_date}} - {{flowsupplier.verification.schedule_time}} 
        </p>
        </template> 
        <template v-if="verificationPlanning=='passed'">

        </template>

        <template v-if="verificationPlanning=='today'">

        </template>

        <template v-if="verificationPlanning=='finished'">

        </template>

        <template v-if="verificationPlanning=='awaiting_schedule'">
          <p class="text-primary font-semibold m-0 pr-4">
          <b>Planlama tarihi:</b> 
          {{flowsupplier.verification.schedule_date}} - {{flowsupplier.verification.schedule_time}} 
        </p>
        </template>

        <template v-if="verificationPlanning=='under_review'">

        </template>

      </div>
    </div>
    </div>
  </div>
</template>

<template v-if=" this.flowsupplier.flow.type=='audit'">
  <div class="grid">
    <div class="col-12">
      <div class="rage_wrap_outer ml-2 mt-1">
      <div class="rage_wrap_inner animate_class">
        {{verificationPlanning}}        
      </div>
    </div>
    </div>
  </div>
</template>


<!--<div  v-if="!daydifference" style="height: 29px;"></div>-->







</div>
</template>

<script>
import moment from "moment"
import DateRangedisplay from "./DateRangedisplay"
export default {

  name: 'SupplierDashboardFlowsupplier',
  components:{DateRangedisplay},
  props:["flowsupplier","projectsupplier"],
  data () {
    return {

    }
  },
  computed:{
    verificationPlanning()
    {
      if(this.flowsupplier.verification)
      {
        //if scheduled
        if(this.flowsupplier.verification.status=="scheduled" || this.flowsupplier.verification.status=="rescheduled")
        {
          let is_today = this.isToday(this.flowsupplier.verification.schedule_date)
          if(is_today=="today")
          {
            return "today"
          }
          if(is_today=="later")
          {
            return "later"
            
          }
          if(is_today=="passed")
          {
            return "passed"
          }
        }
        //if scheduled

        //if awaiting_schedule
        if(this.flowsupplier.verification.status=="awaiting_schedule")
        {
          return "awaiting_schedule"
        }
        //if awaiting_schedule

        //if finished
        if(this.flowsupplier.verification.status=="finished")
        {
          if(this.flowsupplier.status=="under_review")
          {
            return "under_review"
          }
          else
          {
            return "finished"
          }
          
        }
        //if finished
      }
    },
  	flowtype()
    {
      if(this.flowsupplier.flow.type=="self_evaluation")
      {
        return this.$store.state.languages.lang_phrases.self_evaluation
      }
      if(this.flowsupplier.flow.type=="education")
      {
        return  this.$store.state.languages.lang_phrases.egitim
      }
      if(this.flowsupplier.flow.type=="verification")
      {
        return  this.$store.state.languages.lang_phrases.verification
      }
      if(this.flowsupplier.flow.type=="audit")
      {
        return  this.$store.state.languages.lang_phrases.audit
      }
    },
    flowstatus()
    {
      if(this.flowsupplier.verification)
      {
      	if(this.flowsupplier.verification.status=="awaiting_schedule")
      	{
      		return this.$store.state.languages.lang_phrases.planlamada
      	}
      	if(this.flowsupplier.verification.status=="scheduled" || this.flowsupplier.verification.status=="rescheduled")
      	{
      		return this.$store.state.languages.lang_phrases.planlandi
      	}
      	if(this.flowsupplier.verification.status=="finished")
      	{
      		return this.$store.state.languages.lang_phrases.tamamlandi0
      	}
      }

      if(this.flowsupplier.status=="created")
      {
        return this.$store.state.languages.lang_phrases.olusturuldu
      }
      if(this.flowsupplier.status=="viewed")
      {
        return this.$store.state.languages.lang_phrases.goruntulendi
      }
      if(this.flowsupplier.status=="started")
      {
        return this.$store.state.languages.lang_phrases.baslandi
      }
      if(this.flowsupplier.status=="finished")
      {
        return this.$store.state.languages.lang_phrases.tamamlandi0
      }
      if(this.flowsupplier.status=="under_review")
      {
        return this.$store.state.languages.lang_phrases.degerlendirmede
      }
      if(this.flowsupplier.status=="canceled")
      {
        return this.$store.state.languages.lang_phrases.iptal_edildi
      }
      if(this.flowsupplier.status=="correction_requested")
      {
        return this.$store.state.languages.lang_phrases.duzeltme_talebi_incelemede
      }

    },
    flowtypecolor()
    {
      if(this.flowsupplier.flow.type=="self_evaluation")
      {
        return "#ff6600"
      }
      if(this.flowsupplier.flow.type=="education")
      {
        return "#3b82f6"
      }
      if(this.flowsupplier.flow.type=="verification")
      {
        return "#7e2f8d"
      }
      if(this.flowsupplier.flow.type=="audit")
      {
        return "#352f8d"
      }
    },

    flowstatuscolor()
    {

      if(this.flowsupplier.verification)
      {
      	if(this.flowsupplier.verification.status=="awaiting_schedule")
      	{
      		return "#352f8d"
      	}
      	if(this.flowsupplier.verification.status=="scheduled" || this.flowsupplier.verification.status=="rescheduled")
      	{
      		return "#7e2f8d"
      	}
      	if(this.flowsupplier.verification.status=="finished")
      	{
      		return "#4dc247"
      	}
      }

      if(this.flowsupplier.status=="created")
      {
        return "#352f8d"
      }
      if(this.flowsupplier.status=="viewed")
      {
        return "#7e2f8d"
      }
      if(this.flowsupplier.status=="started")
      {
        return "#dd4b39"
      }
      if(this.flowsupplier.status=="finished")
      {
        return "#4dc247"
      }
      if(this.flowsupplier.status=="under_review")
      {
        return "#ff6600"
      }
      if(this.flowsupplier.status=="canceled")
      {
        return "#a82400"
      }
      if(this.flowsupplier.status=="correction_requested")
      {
        return "#3b82f6"
      }
      
    },
  	collapseclass()
  	{
  		if(this.collapsed)
  		{
  			return "animate-class collapsed"
  		}
  		else
  		{
  			return "animate-class expanded"
  		}
  	},
  	daydifference()
  	{
  		let start
  		let end
  		let today = moment()
  		let diff
      let today_diff
      let days_left
      if(!this.flowsupplier.flow.start_date || !this.flowsupplier.flow.end_date)
      {
        return null
      }

  		if(this.flowsupplier.flow.start_date)
  		{
  			start = moment(this.flowsupplier.flow.start_date)
  		}

  		if(this.flowsupplier.flow.end_date)
  		{
  			end = moment(this.flowsupplier.flow.end_date)
  		}
      if(this.flowsupplier.exception_expire_date)
      {
        end = moment(this.flowsupplier.exception_expire_date)
      }

  		if(start && end)
  		{
  			diff = end.diff(start, 'days') 
  		}
  		if(diff)
  		{
        today_diff = today.diff(start, 'days') 
        days_left = end.diff(today, 'days') 

  		}

  		if(today_diff)
  		{
  			days_left++
  			if(today<start)
  			{
  				return null
  			}
  			else
  			{
  				let data = Math.ceil((today_diff/diff)*100)
  				if(data>100) 
  				{
  					return {daydifference:100,daysleft:0}
  				}
  				else
  				{
  					return {daydifference:data,daysleft:days_left}
  				}
  			}
  			
  			
  		}
  		else
  		{
  			return null
  		}

  		
  	},
  },
  methods:{
  	show()
  	{
  		console.log(this.flowsupplier)
  		console.log(this.isToday(this.flowsupplier.verification.schedule_date))

  	},
  	isToday(date)
  	{  

  		let start = moment(date)
  		let today = moment()
  		console.log("isToday")
  		console.log(start)
  		console.log(today)
  		if(start.isBefore(today))
  		{
  			return "passed"
  		}

  		if(start.isSame(today))
  		{
  			return "today"
  		}

  		if(start.isAfter(today))
  		{
  			return "later"
  		}


  	},
  }
}
</script>

<style lang="css" scoped>
  .rage_wrap_outer{
    width: 100%;
    height: 13px;
    position: relative;
  }
  .rage_wrap_inner{
    height: 12px;
    width: 100%;
    position: absolute;
    margin: 2px;
  }
</style>